import { Skeleton } from "@/components/ui/skeleton";
import { memo } from "react";
import { InscricaoConcluidaSkeleton } from "./InscricaoConcluidaSkeleton";

/**
 * Skeleton de "boot" do fluxo de inscrição — usado como fallback de Suspense
 * enquanto o chunk do layout de inscrição carrega (antes do header real).
 * Espelha o header do `_inscricao` + a casca do funil para evitar o spinner
 * genérico e manter o carregamento consistente com `InscricaoFunnelSkeleton`.
 */
export const InscricaoBootSkeleton = memo(function InscricaoBootSkeleton() {
  return (
    <div className="flex min-h-dvh flex-col bg-white">
      <header className="relative z-50 shrink-0 border-b border-[#dfe0e4] bg-white shadow-lg">
        <div className="container mx-auto px-4 py-2.5 sm:px-6 lg:w-2/3 xl:w-1/2">
          <div className="m-auto flex w-full items-center justify-between">
            <div className="flex w-full items-center">
              <Skeleton variant="shimmer" className="size-7 rounded-full" />
              <Skeleton variant="shimmer" className="ml-auto h-7 w-24 rounded-md md:h-8 md:w-28" />
            </div>
          </div>
        </div>
      </header>
      <main className="flex min-h-0 flex-1 flex-col bg-[#f7f9fb]">
        <div className="mx-auto w-full max-w-lg px-4 pt-2 sm:px-6">
          <div className="flex flex-col gap-2 py-2.5">
            <Skeleton variant="shimmer" className="h-6 w-48 rounded-full" />
            <Skeleton variant="shimmer" className="h-3 w-32 rounded-full" />
          </div>
          <Skeleton variant="shimmer" className="mb-3 h-2 w-full rounded-full" />
          <InscricaoConcluidaSkeleton />
        </div>
      </main>
    </div>
  );
});
